import React from 'react';

import loaderLogo from 'assets/loaderLogo.gif';

import './styles.css';

const Loader: React.FC = () => {
  return (
    <div className="container">
      <img src={loaderLogo} alt="logo" />
    </div>
  );
};

export default Loader;
